import { createSlice } from '@reduxjs/toolkit';
import { catalogDeleteProjectType } from './catalogAsyncThunk';

const catalogDeleteProjectTypeSlice = createSlice({
  name: "catalog",
  initialState: {
    isLoading: false,
    isSuccess: false,
    failCode: 0,
  },
  reducers: {},
  extraReducers: {
    [catalogDeleteProjectType.pending]: (state, action) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.failCode = 0;
    },
    [catalogDeleteProjectType.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
    },
    [catalogDeleteProjectType.rejected]: (state, action) => {
      state.isLoading = false;
      state.failCode = action.payload.status;
    },
  },
});

export default catalogDeleteProjectTypeSlice.reducer;